import BaseDialogCmp from "../../../components/BaseDialog/BaseDialogCmp.js";
import AccessLevel from "../AccessLevel.js";
import {safeText} from "../../util/CommonUtils.js";
import {createOrgNameUrlTemplate, extractOrgNameFromUrl} from "../../util/UrlUtils.js";

export default class OrgBillingQuotaErrorHandler {
    /** @type {BaseDialogCmp} */
    #refreshPopup;
    #org;
    /**
     * @type {OrgRepository}
     */
    #orgRepo;

    constructor(orgRepo) {
        this.#refreshPopup = new BaseDialogCmp({btnCancel: "Close", btnOk: "Refresh"});
        this.#orgRepo = orgRepo;
    }

    /** @param {HttpError} error */
    async handle(error) {
        if (this.#refreshPopup.isAlreadyShown())
            return
        this.#refreshPopup.onOk(() => {
            location.reload()
        });
        this.#refreshPopup.showHtml(await this.#getDialogContent(error));
    }

    async #getDialogContent(error) {
        let reasonText = 'ran out of space';
        if (error.isOrgRequestsQuotaReached)
            reasonText = 'has reached its request limit per day (the day ends at midnight UTC)';
        const org = await this.#getOrg();
        if (org.userAccessLevel.meetsOrExceeds(AccessLevel.ADMIN)) {
            return `
              <div class="dialog__main-content">
                <b>${safeText(org.displayName)} </b> 
                ${reasonText}, to change the limits visit 
                <a target="_blank" href="${createOrgNameUrlTemplate(org.name)}/settings?screen=billing">Billing & Quotas</a> page
			  </div>
		`;
        }
        return `<div class="dialog__main-content"><b>${safeText(org.displayName)}</b> ${reasonText}. Contact the administrator</div>`;
    }

    async #getOrg() {
        if (!this.#org)
            this.#org = await this.#orgRepo.getOrganization(extractOrgNameFromUrl());
        return this.#org;
    }
}